import { Center, Float, OrbitControls, Text3D } from "@react-three/drei";
import { Canvas } from "@react-three/fiber";
import { useLangContext } from "context/Lang";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";


/*font="/fonts/Geist_Bold.json"*/
const NotFound3D = () => {
    return (
        <Center>
            <Float speed={2} rotationIntensity={0.5} floatIntensity={0.5}>
                <Text3D
                    font="/assets/fonts/helvetiker_regular.typeface.json"
                    size={1.5}
                    height={0.25}
                    curveSegments={12}
                    bevelEnabled
                    bevelSize={0.03}
                    bevelThickness={0.03}
                >
                    404
                    <meshStandardMaterial
                        color="rgb(var(--color-primary-600))"
                        metalness={1}
                        roughness={0.3}
                    />
                </Text3D>
            </Float>
        </Center>
    );
};

export const PageNotFound = () => {

    const { gW } = useLangContext();

    return (
        <div className="relative flex min-h-screen flex-col items-center justify-center overflow-hidden bg-gradient-to-br from-background via-background to-primary/10">

            {/* 3D Background */}
            <div className="absolute inset-0 z-0 opacity-30">
                <Canvas camera={{ position: [0, 0, 5], fov: 45 }}>
                    <ambientLight intensity={1} />
                    <spotLight
                        position={[10, 10, 10]}
                        angle={0.2}
                        penumbra={1}
                        intensity={1}
                    />
                    <pointLight position={[-10, -10, -10]} intensity={1} />
                    <NotFound3D />
                    <OrbitControls enableZoom={false} enablePan={false} autoRotate autoRotateSpeed={1} />
                </Canvas>
            </div>

            {/* Content */}
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                className="relative z-0 text-center px-4"
            >
                <motion.div
                    initial={{ scale: 0.8, opacity: 0 }}
                    animate={{ scale: 1, opacity: 1 }}
                    transition={{ duration: 0.5, delay: 0.2 }}
                    className="mb-8"
                >
                    <h1 className="mb-4 text-9xl font-extrabold text-primary">
                        404
                    </h1>

                    <h2 className="mb-2 text-3xl text-primary-900 font-bold md:text-4xl">
                        {gW("page-not-found") || "Page Not Found"}
                    </h2>

                    <p className="mx-auto max-w-md text-lg text-primary-900 text-muted-foreground">
                        {gW("oops-virtual-space") ||
                            "Oops! Looks like you've ventured into uncharted virtual space."}
                    </p>
                </motion.div>

                {/* Buttons */}
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, delay: 0.4 }}
                    className="flex flex-col items-center justify-center gap-4 sm:flex-row"
                >
                    <Link to="/">
                        <button className="px-6 py-3 rounded-xl bg-primary-600 text-white font-medium hover:bg-primary-700 active:bg-primary-800 transition-all shadow-md">
                            {gW("return-home") || "Return Home"}
                        </button>
                    </Link>

                    {/* Example extra button */}
                    {/* <Link to="/login">
                        <button className="px-6 py-3 rounded-xl border border-primary-600 text-primary hover:bg-primary-50 transition">
                            {gW("sign-in")}
                        </button>
                    </Link> */}
                </motion.div>

                {/* Support */}
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 0.5, delay: 0.6 }}
                    className="mt-12"
                >
                    <p className="text-sm text-primary-900 text-muted-foreground">
                        {gW("need-help") || "Need help?"}{" "}
                        <Link to="/" className="text-primary hover:underline">
                            {gW("contact-support") || "Contact support"}
                        </Link>
                    </p>
                </motion.div>
            </motion.div>

        </div>
    );
};